import { Component } from 'react';
import { Link } from 'react-router';
import Loading from '../../common/lib/Loading';
import PageNotFound from '../../common/lib/PageNotFound';
import type { MultiLang } from '../../config';
import Functions from '../../functions';
import type BulletinContext from '../lib/BulletinContext';
import BulletinStoryItem from '../lib/BulletinStoryItem';
import BulletinUtils from '../lib/BulletinUtils';

interface Props {
    lang: MultiLang;
    mydirname: string;
}

interface State {
    loading: boolean;
    context: BulletinContext | null;
}

class BulletinRecentNews extends Component<Props, State> {
    private isActive: boolean;

    constructor(props: Props) {
        super(props);
        this.state = {
            loading: true,
            context: null,
        };
        this.isActive = false;
    }

    componentDidMount() {
        this.isActive = true;
        this.updateContext();
    }

    componentDidUpdate(prevProps: Props) {
        const { mydirname } = this.props;
        const prevMydirname = prevProps.mydirname;
        if (mydirname !== prevMydirname) {
            this.setState({ loading: true, context: null });
            this.updateContext();
        }
    }

    componentWillUnmount() {
        this.isActive = false;
    }

    async updateContext() {
        const { mydirname } = this.props;
        const context = await BulletinUtils.getContext(mydirname);
        if (this.isActive) {
            this.setState({ loading: false, context });
        }
    }

    render() {
        const { lang } = this.props;
        const { loading, context } = this.state;
        if (loading) {
            return <Loading />;
        }
        if (context === null) {
            return <PageNotFound lang={lang} />;
        }
        const module = context.getModule();
        if (module === null) {
            return <PageNotFound lang={lang} />;
        }
        const stories = context.getStories(0, 10, 0);
        return (
            <div className={`bulletin ${module.dirname} recentnews-block`}>
                {stories
                    .filter((_story, index) => index < 3)
                    .map((story) => {
                        return (
                            <BulletinStoryItem
                                key={story.id}
                                lang={lang}
                                context={context}
                                story={story}
                                isList={true}
                            />
                        );
                    })}
                <ul>
                    {stories
                        .filter((_story, index) => index >= 3)
                        .map((story) => {
                            return (
                                <li key={story.id}>
                                    <Link to={context.getStoryUrl(story.id)}>{Functions.mlang(story.title, lang)}</Link>{' '}
                                    ({story.posttime})
                                </li>
                            );
                        })}
                </ul>
                <div style={{ textAlign: 'right' }}>
                    <Link to={context.getTopicUrl(0, 10, 10)}>[more]</Link>
                </div>
            </div>
        );
    }
}

export default BulletinRecentNews;
